export { useHorizontalNavMenuLink as default };
import * as vue_composition_api from '@vue/composition-api';
import core_layouts_utils from '@core/layouts/utils';


function useHorizontalNavMenuLink(item) {
  const isActive = vue_composition_api.ref(false);
  const linkProps = core_layouts_utils.navLinkProps(item);
  const updateIsActive = () => {
    isActive.value = core_layouts_utils.isNavLinkActive(item);
  };
  return {
    isActive,
    linkProps,
    updateIsActive
  };
}

